import type { WebapiEndpointBuilder } from '@/api/webapi.ts';
import { forwardAccumulatorApi } from '@/store/forwardAccumulator/api/index.ts';

export type CancelForwardAccumulatorBody = {
  rfsId: string;
  tileId: string;
  /**
   * Normally, when we cancel the RFS, we keep the last quote received to display the expired quote.
   * If this is, true, we discard the quote and go back to the initial state (CANCELLED)
   */
  removeQuote?: boolean;
};

export const cancelForwardAccumulatorRfs = (builder: WebapiEndpointBuilder) => {
  return builder.mutation<unknown, CancelForwardAccumulatorBody>({
    query: (body) => {
      return {
        url: '/fxAccumulator/rfs/cancel',
        method: 'POST',
        body: {
          rfsId: body.rfsId,
        },
      };
    },
    onQueryStarted({ rfsId }, { dispatch }): Promise<void> | void {
      dispatch(forwardAccumulatorApi.internalActions.removeMutationResult({ fixedCacheKey: rfsId }));
    },
  });
};
